import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import businessService from "../services/businessService";
import { toast } from "react-toastify";

/**
 * Get my business
 */
export const getMyBusiness = createAsyncThunk(
  "business/getMy",
  async (_, { rejectWithValue }) => {
    try {
      const response = await businessService.getMyBusiness();
      return response.business;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch business");
    }
  }
);

/**
 * Create or update business
 */
export const createOrUpdateBusiness = createAsyncThunk(
  "business/createOrUpdate",
  async (businessData, { rejectWithValue }) => {
    try {
      const response = await businessService.createOrUpdateBusiness(businessData);
      toast.success(response.message || "Business saved successfully");
      return response.business;
    } catch (error) {
      toast.error(error.message || "Failed to save business");
      return rejectWithValue(error.message || "Failed to save business");
    }
  }
);

/**
 * Delete business
 */
export const deleteBusiness = createAsyncThunk(
  "business/delete",
  async (businessId, { rejectWithValue }) => {
    try {
      await businessService.deleteBusiness(businessId);
      toast.success("Business deleted successfully");
      return businessId;
    } catch (error) {
      toast.error(error.message || "Failed to delete business");
      return rejectWithValue(error.message || "Failed to delete business");
    }
  }
);

// Initial state
const initialState = {
  business: null,
  loading: false,
  error: null,
  saveLoading: false,
  saveSuccess: false,
};

// Slice
const businessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {
    clearBusiness: (state) => {
      state.business = null;
    },
    resetSave: (state) => {
      state.saveSuccess = false;
    },
    clearErrors: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get My Business
      .addCase(getMyBusiness.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMyBusiness.fulfilled, (state, action) => {
        state.loading = false;
        state.business = action.payload;
        state.error = null;
      })
      .addCase(getMyBusiness.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create or Update Business
      .addCase(createOrUpdateBusiness.pending, (state) => {
        state.saveLoading = true;
        state.saveSuccess = false;
        state.error = null;
      })
      .addCase(createOrUpdateBusiness.fulfilled, (state, action) => {
        state.saveLoading = false;
        state.saveSuccess = true;
        state.business = action.payload;
        state.error = null;
      })
      .addCase(createOrUpdateBusiness.rejected, (state, action) => {
        state.saveLoading = false;
        state.saveSuccess = false;
        state.error = action.payload;
      })
      // Delete Business
      .addCase(deleteBusiness.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteBusiness.fulfilled, (state) => {
        state.loading = false;
        state.business = null;
        state.error = null;
      })
      .addCase(deleteBusiness.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearBusiness, resetSave, clearErrors } = businessSlice.actions;
export default businessSlice.reducer;

